import { render, staticRenderFns } from "./GTMetrixRenderer.vue?vue&type=template&id=7df5e3ee&scoped=true"
import script from "./GTMetrixRenderer.vue?vue&type=script&lang=js"
export * from "./GTMetrixRenderer.vue?vue&type=script&lang=js"
import style0 from "./GTMetrixRenderer.vue?vue&type=style&index=0&id=7df5e3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df5e3ee",
  null
  
)

export default component.exports